const uz = {
  mainTitle: "Ro'yxatdan o'tish",
  selectExam: "Imtihonni tanlang",
  selectVenue: "Joynini tanlang",
  selectModule: "Modulni tanlang",
  selectTestDate: "Test uchun o'zingizga ma'qul sanani tanlang",
  fillDetails: "Ma'lumotlaringizni to'ldiring",
  residenceCountry: "Fuqarolingiz",
  Other: "Boshqa",
  Uzbekistan: "O'zbekiston",
  passportNo: "Passport yoki ID raqam (AA1234567)",
  invalidPassportNo: "Iltimos, to'g'ri passport yoki ID raqam kiriting.",
  pinpp: "PINFL (14 raqam)",
  invalidPinpp: "Iltimos, to'g'ri 14 raqamli PINFL kiriting.",
  pinppLookupError: "PINFL bo'yicha ma'lumot olinmadi, iltimos tekshiring",
  dob: "Tug'ilgan sana",
  wrongPassportOrDob:
    "Iltimos, to'g'ri passport raqami yoki tug'ilgan sana kiriting.",
  proceed: "Davom etish",
  firstName: "Ism (PASSPORT bo'yicha)",
  lastName: "Familiya (PASSPORT bo'yicha)",
  gender: "Jins",
  male: "Erkak",
  female: "Ayol",
  selectCertificateRegion: "Sertifikat yuborish uchun shahar tanlang:",
  phoneNumber: "Telefon raqam (998 bilan)",
  invalidPhoneNumber: "Iltimos, to'g'ri telefon raqam kiriting.",
  email: "Email",
  invalidEmail: "Iltimos, to'g'ri email kiriting.",
  attachPassport: "Passport yuklash",
  readAgreed: "Ko'rsatlingan ",
  termsConditions: "shartlarga roziman",
  submit: "Yuborish",
  telephone: "Telefon",
  address1: "Manzil: 2-3 Bunyodkor shoh ko'cha, CIU Binosi 4-qavat,",
  address2: "Toshkent, O'zbekiston 100043",
  submittedSucces: "Siz muvaffaqaiyatli ro'yxatdan o'tdingiz ",
  checkEmail: "Keyingi qadamlar haqida bilish uchun emailingizni tekshiring. ",
  payNow: "To'lov qilish",
  contacts: "Aloqa",
  results: "Natijalar",
  examDates: "Imtihon sanalari",
  whichTest: "Qaysi test uchun to'lamoqchisiz?",
  examDate: "Imtihon sanasi",
  examDateRequired: "Imtihon sanasini tanlang",
  examRegion: "Viloyat",
  paymentFor: "To'lov turi",
  enterEnquiry: "So'rovnoma raqamini kiriting (Enquiry ID)",
  next: "Keyingisi",
  examDetails: "Imtihon tafsilotlari",
  date: "Sana",
  region: "Viloyat",
  status: "Holati",
  examPrice: "Imtihon narxi",
  processingFee: "Ustama",
  totalPay: "To'lov umumiy summasi",
  price: "Narx",
  cardNo: "Karta raqami",
  validThru: "Amal qilish muddati",
  phoneNo: "Telefon raqami",
  enterCode: "SMSdan kodni kiriting",
  pay: "To'lash",
  securePaymentTitle: "Xavfsiz to'lov jarayoni:",
  securePayment1:
    "Sizning xavfsizligingiz bizning ustunlikimizdir. Biz sizning karta ma'lumotlaringizni saqlamaymiz. Barcha to'lovlar xavfsiz ravishda",
  securePayment2: "orqali ishlaydi. ",
  receipt: {
    title: "MA'LUMOTNOMA",
    info: `MCHJ "Edu Action" Test Markazi quyidagi nomzodni muvaffaqiyatli to'lovini tasdiqlaydi:`,
    name: "Ism Sharifi",
    idNo: "ID/Passport №",
    paymentDate: "To'lov sanasi",
    paymentAmount: "To'lov summasi",
    exam: "Imtihon",
    module: "Modul",
    qrInfo: `QR kodi sizning to'lovingizni tasdiqlash uchun dalildir.`,
  },
  selectProvider: "To'lov usulini tanlang",
  codeSent: "Kod yuborilgan raqam ",
  cvc: "CVV / CVC",
  cvcRequired: "Kartangiz orqasidagi 3 xonali kodni kiriting",
  promocode: "Promokod",
  promocodePlaceholder: "Promokodni kiriting",
  promocodeApply: "Qo'llash",
  promocodeRemove: "Olib tashlash",
  promocodeApplied: "Promokod qo'llanildi",
  promocodeInvalid: "Bu promokoddan foydalanib bo'lmaydi",
  promocodeOff: "chegirma",
  promocodeDiscount: "Promokod chegirmasi",
  promocodeSelectModule: "Avval nima uchun to'layotganingizni tanlang",
  menu: "Menyu",
  backToTop: "Yuqoriga",
  paymentFailedTitle: "To'lov amalga oshmadi",
  paymentFailedBody: "To'lov yakunlanmadi. Karta ma'lumotlari va balansni tekshirib, qayta urinib ko'ring. Agar kartangizdan pul yechilgan bo'lsa, biz bilan bog'laning.",
  tryAgain: "Qayta urinish",
  needHelp: "Yordam kerakmi?",
  notFoundTitle: "Sahifa topilmadi",
  notFoundBody: "Havola eskirgan yoki noto'g'ri yozilgan bo'lishi mumkin.",
  goToPayment: "To'lov sahifasiga o'tish",
  loadingReceipt: "Ma'lumotnoma yuklanmoqda…",
  receiptNotFoundTitle: "Ma'lumotnoma topilmadi",
  receiptNotFoundBody: "Havola yoki QR kodni tekshiring. Hozirgina to'lagan bo'lsangiz, bir daqiqadan so'ng havolani qayta oching.",
  loadFailed: "Ma'lumotnomani yuklab bo'lmadi",
  loadFailedBody: "Internet aloqasini tekshirib, qayta urinib ko'ring.",
  print: "Chop etish",
  selectPlaceholder: "Tanlang…",
  clear: "Tozalash",
  intlCardTitle: "Xalqaro kartalar (Visa, Mastercard)",
  invalidCardNumber: "16 xonali karta raqamini to'liq kiriting.",
  invalidPhone9: "Kartaga ulangan 9 xonali telefon raqamini kiriting.",
  otpRequired: "Telefoningizga yuborilgan SMS kodni kiriting.",
  genericError: "Xatolik yuz berdi. Qayta urinib ko'ring.",
  enquiryExpired: "Bu so'rovnoma muddati tugagan, uni to'lab bo'lmaydi. Yangisini olish uchun biz bilan bog'laning.",
  enquiryRequired: "So'rovnoma raqamini kiriting.",
  enquiryNotFound: "Bu raqamli so'rovnoma topilmadi. Raqamni tekshirib, qayta urinib ko'ring.",
  instructions: "Yo'riqnoma",
  checkAnotherEnquiry: "Boshqa so'rovnomani tekshirish",
  cardDetails: "Karta ma'lumotlari",
};

export default uz;
